import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  Divider,
  Form,
  Input,
  Select,
  Button,
  Upload,
  Radio,
  Tabs,
  Tooltip,
  message,
  Popconfirm,
  Table,
  TableColumnsType,
  Dropdown,
  Menu,
  Modal,
} from "antd";
import { InboxOutlined, CheckOutlined } from "@ant-design/icons";
import { Popover } from 'antd';
import jwt, { JwtPayload } from "jsonwebtoken";
import ReactMarkdownPreview from "@uiw/react-markdown-preview";
import { useLocation, useHistory } from "react-router-dom";
import { useAppSelector } from "../../store/hook";
import { fetchProblems, ProblemModel } from "../../api/problem";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { getProblemFileCOS } from "../../cos/submission";
import { getTrackReg, TrackRegistrationModel } from "../../api/track";
import { getTeam } from "../../api//team";
import { TeamModel } from "../../api/track";
import { SubmitFileModel, submit, submitgit, fetchTeamSubmission, SubmitModel, SubmitStatus } from "../../api/submission";
import COS from "cos-js-sdk-v5";
import moment from "moment";
import { login } from "../../api/login";
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
const { Dragger } = Upload;
const { Title } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;
interface IProblem {
  contestId: number;
  trackId: number;
  stageId: number;
  problemId: number;
  problem: ProblemModel;
  endCallback?: () => undefined | void;
}
export const Submit: React.FunctionComponent<IProblem> = (prop) => {
  const location = useLocation();
  const [submitType, setSubmitType] = useState(0);
  const { contestId, trackId, stageId, problemId, problem } = prop;
  const endCallback = prop?.endCallback || (() => { });
  const [submitRecord, setSubmitRecord] = useState<
    Record<string, SubmitFileModel>
  >({});
  const [trackReg, setTrackReg] = useState<TrackRegistrationModel>();
  const [team, setTeam] = useState<TeamModel>();
  const status = useAppSelector((state) => state.user.user);
  const key = useAppSelector((state) => state.user.key);
  const SubmitCOS = getProblemFileCOS(
    key,
    contestId,
    trackId,
    stageId,
    problemId
  );
  const [isFileError, setIsFileError] = useState(false);
  const history = useHistory();
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [problems, setProblems] = useState<ProblemModel[]>([]);
  useEffect(() => {
    if (status === "guest") {
          login(location.pathname);
        }
    getTrackReg(key, contestId, trackId).then((data) => {
      if(data && data.team) {
        getTeam(key, contestId, trackId, data.team).then((data) => {
          // console.log("setTeam", data);
          setTeam(data);
        });
      }
    });
  }, [location, status, key, id, history, contestId, trackId, stageId]);
  const upload = (submitFileName: string) => (prop: UploadRequestOption) => {
    getTrackReg(key, contestId, trackId).then((data) => {

      if (status === "guest") {
        login(location.pathname);
      }
      if (data && data.team) {
        const Key = `${contestId}/${trackId}/${stageId}/${problemId}/${data.team}/${submitFileName}`
        SubmitCOS.uploadFile({
          Bucket: "submit-1256691515",
          Region: "ap-guangzhou",
          SliceSize: 1024 * 1024 * 20,
          Key,
          Body: prop.file,
          onProgress(progressData) {
            if (prop.onProgress)
              prop.onProgress({
                ...new Event("onProgress"),
                ...progressData,
                percent: progressData.percent * 100,
                lengthComputable: false,
              });
            return;
          },
          onFileFinish: ((err: COS.CosError, data: COS.UploadFileResult, options: any) => {
            if (err) {
              console.log(err);
            }
            if (!err) {
              const t: Record<string, SubmitFileModel> = {};
              t[submitFileName] = {
                name: submitFileName,
                hashname: Key,
                version: data.headers ? (data.headers["x-cos-version-id"] || "") : "",
              };
              setSubmitRecord({
                ...submitRecord,
                ...t,
              });
              if (prop.onSuccess)
                prop.onSuccess(data, null as any as XMLHttpRequest);
            }
          }) as any,
        }).then(data => { console.log(1, data) });
      }
    });
  };
  return (
    <div className="site-layout-content">
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        size="large"
      >
        <Form.Item label={t("提交种类")} name="submitType">
          <Radio.Group
            onChange={(e) => {
              setSubmitType(e.target.value);
            }}
            defaultValue={0}
          >
            <Radio.Button value={0}>{t("文件提交")}</Radio.Button>
            <Radio.Button value={1}>{t("从我的仓库提交")}</Radio.Button>
          </Radio.Group>
        </Form.Item>
        {submitType === 0 &&
          problem.submitFile.map((submitFile) => (
            <Form.Item label={submitFile.name} name="upload">
              <Tooltip title={submitFile.desc}>
                <Dragger
                  name="file"
                  maxCount={1}
                  key={`submit-${problemId}-${submitFile.name}`}
                  customRequest={upload(submitFile.name)}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">{t("点击或拖拽文件以上传")}</p>
                </Dragger>
              </Tooltip>
            </Form.Item>
          ))}
        {submitType === 1 && (
          <Form.Item label={t("仓库文件路径")} name="upload">
            {team?.giturl}
          </Form.Item>
        )}
        {/*<Form.Item label={t("开源协议")} name="opensource">
          <Select defaultValue="no" style={{ width: 120 }}>
            <Option value="MIT">MIT</Option>
            <Option value="Apache">Apache</Option>
            <Option value="BSD">BSD</Option>
            <Option value="qizhi">启智开源</Option>
            <Option value="no">不开源</Option>
          </Select>
        </Form.Item>*/}
        <Form.Item label={t("提交")} name="submit">
          <Button type="primary" onClick={
            (opensource:any) => {
              if(submitType===1)
              {
                if(team) {
                  var target = {
                    name: "zip",
                    hashname: team?.giturl,
                    version: "",
                  };
                  submitgit(key, contestId, trackId, stageId, problemId, [target],opensource).then(() => {
                    message.success(t("提交成功"))
                    endCallback();
                  }).catch(err => {
                    console.log(err);
                    if (err.info) {
                      message.error(t("提交失败")+": " + err.info)
                    } else {
                      message.error(t("提交失败")+": " + err)
                    }
                    endCallback();
                  })
                }
                return;
              }
              else 
              if(Object.values(submitRecord).length < problem.submitFile.length){
                setIsFileError(true);
              }
              else{
                submit(key, contestId, trackId, stageId, problemId, Object.values(submitRecord),opensource).then(() => {
                  message.success(t("提交成功"))
                  endCallback();
                }).catch(err => {
                  console.log(err);
                  if (err.info) {
                    message.error(t("提交失败")+": " + err.info)
                  } else {
                    message.error(t("提交失败")+": " + err)
                  }
                  endCallback();
                })
              }
            }
          }> <CheckOutlined /> {t("确定")}</Button>
          <Modal title="提示" visible={isFileError} onOk={()=>setIsFileError(false)} onCancel={()=>setIsFileError(false)} okText={t("确认")} cancelText={t("取消")}
            footer={[
              <Button key="ok" onClick={()=>setIsFileError(false)} type = "primary">
                {t("确定")}
              </Button>,
            ]}
          >
            <p>{t("请检查文件正确性并确认上传完毕")}</p>
          </Modal>
        </Form.Item>
      </Form>
    </div>
  );
};

interface ISubmits {
  contestId: number;
  trackId: number;
  stageId: number;
  problemId: number;
  hashTag: number;
}

export const MySubmit: React.FunctionComponent<ISubmits> = (prop) => {
  const { contestId, trackId, stageId, problemId, hashTag } = prop;
  const key = useAppSelector((state) => state.user.key);
  const [submission, setSubmission] = useState<SubmitModel[]>([]);
  const status = useAppSelector((state) => state.user.user);
  const location = useLocation();
  const SubmitCOS = getProblemFileCOS(
    key,
    contestId,
    trackId,
    stageId,
    problemId
  );
  const downloadFile = (file: SubmitFileModel) => {
    getTrackReg(key, contestId, trackId).then((data) => {
      if (data && data.team) {
        SubmitCOS.getObjectUrl({
          Bucket: "submit-1256691515",
          Region: "ap-guangzhou",
          Key: file.hashname,

        }, (err, data) => {
          if (err) console.log(err);
          else if (data.Url) {
            var downloadUrl = data.Url + (data.Url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment' + `&versionId=${file.version}`; // 补充强制下载的参数
            window.open(downloadUrl); // 这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
          }
        });
      }
    })

  }
  useEffect(() => {
    if (status === "guest") {
          login(location.pathname);
        }
    
    if (contestId > 0 && trackId > 0 && stageId > 0 && problemId > 0) {
      fetchTeamSubmission(key, contestId, trackId, stageId, problemId).then(data => {
        data.sort((a, b) => b.id - a.id)
        setSubmission(data);
      })
    }
  }, [key, contestId, trackId, stageId, problemId, hashTag])

  const columns: TableColumnsType<SubmitModel> = [
    {
      key: "id",
      title: "Id",
      dataIndex: 'id',
      render: (text: SubmitStatus) => <span>#{text}</span>,
    },
    {
      title: t("提交状态"),
      dataIndex: 'status',
      key: "status",
      render: (text: SubmitStatus) => <span>{{
        waiting: t("排队中"), judging: t("评测中"), finished:
          t("已完成"), error: t("评测失败"), cancel : t("评测取消")
      }[text]}</span>,
    },
    {
      key: "score",
      title: t("得分"),
      dataIndex: 'score',
      render: (score: number, rec) => <span>{rec.status === "finished" ? score < 0?t("格式正确"):score.toFixed(6) : "-"}</span>,
    },
    {
      key: "submit_time",
      title: t("提交时间"),
      dataIndex: 'submit_time',
      render: (text: string) => <span>{text ? moment(text).format("YYYY年MMMDo HH:mm") : "-"}</span>,
    },
    {
      key: "submit_time",
      title: t("下载文件"),
      dataIndex: 'file_keys',
      render: (files: SubmitFileModel[]) =>

        <Dropdown overlay={
          <Menu>
            {files.map(file => (
              < Menu.Item key={file.version} onClick={() => { downloadFile(file) }}> {file.name}</Menu.Item>
            ))}
          </Menu>
        } placement="bottomCenter" arrow >
          <Button>{t("文件列表")}</Button>
        </Dropdown>
      ,
    },
    {
      key: "judge_info",
      title: t("评测信息"),
      dataIndex: 'judge_info',
      render: (judge_info: string) => <span>{
        <Popover content={judge_info}>
          <Button shape="circle" icon={<SearchOutlined />}/>
        </Popover>
          

    }</span>,
    },
  ];

  return (<Table dataSource={submission} columns={columns} />)
}

export const Problem: React.FunctionComponent<IProblem> = (prop) => {
  const { contestId, trackId, stageId, problemId, problem } = prop;

  const tabDTitle = `${problem?.description?.title}`;
  const tabDM = tabDTitle.length > 6 ? `${tabDTitle.substr(0, 5)}...` : tabDTitle;
  const tabITitle = `${problem?.datainfo?.title}`;
  const tabIM = tabITitle.length > 6 ? `${tabITitle.substr(0, 5)}...` : tabITitle;
  const tabJTitle = `${problem?.judgeinfo?.title}`;
  const tabJM = tabJTitle.length > 6 ? `${tabJTitle.substr(0, 5)}...` : tabJTitle;
  const [hashTag, setHashTag] = useState(0);
  const [activeKey, setActiveKey] = useState(`article-${problem?.articles[0].id}`);
  const endCallback = () => {
    setActiveKey("submission");
    setHashTag(x => x + 1);
  }
  return (
    <Tabs activeKey={activeKey} style={{ margin: "-36px -40px", padding: "0" }} onChange={(key) => {
      setActiveKey(key);
      if (key == "submission") {
        setHashTag(x => x + 1);
      }
    }}>
      {problem?.articles.map((article) => {
          const tabTitle = `${article.title}`;
          const tabM = tabTitle.length > 6 ? `${tabTitle.substr(0, 6)}...` : tabTitle;
          return(
            article.title.substr(0,2) === "隐藏"?null:
            (
              <TabPane
                key={`article-${article.id}`}
                tab={<Tooltip title={tabTitle}>{tabM}</Tooltip>}
              >
                
                  <Title level={3}>{article.title}</Title>
                  <Divider />
                  <ReactMarkdownPreview source={article.body} />
              </TabPane>
            )
          )
        })}
        
      {problem.description ? (
        <TabPane key="description" tab={<Tooltip title={tabDTitle}>{tabDM}</Tooltip>}>
          <Title level={3}>{problem.description.title}</Title>
          <Divider></Divider>
          <ReactMarkdownPreview source={problem.description.body} />
        </TabPane>
      ) : (
        <></>
      )}
      {problem.datainfo ? (
        <TabPane key="datainfo" tab={<Tooltip title={tabITitle}>{tabIM}</Tooltip>}>
          <Title level={3}>{problem.datainfo.title}</Title>
          <Divider></Divider>
          <ReactMarkdownPreview source={problem.datainfo.body} />
        </TabPane>
      ) : (
        <></>
      )}
      {problem.judgeinfo ? (
        <TabPane key="judgeinfo" tab={<Tooltip title={tabJTitle}>{tabJM}</Tooltip>}>
          <Title level={3}>{problem.judgeinfo.title}</Title>
          <Divider></Divider>
          <ReactMarkdownPreview source={problem.judgeinfo.body} />
        </TabPane>
      ) : (
        <></>
      )}
      {
      <TabPane key="submit" tab={t("提交")}>
        <Submit
          {...{ contestId, trackId, stageId, problemId, problem, endCallback }}
        ></Submit>
      </TabPane>
      }
      <TabPane key="submission" tab={t("我的成绩")} >
        <MySubmit
          {...{ contestId, trackId, stageId, problemId, hashTag }}
        ></MySubmit>
      </TabPane>
    </Tabs>
  );
};
interface IProblemLists {
  contestId: number;
  trackId: number;
  stageId: number;
}
export const ProblemList: React.FunctionComponent<IProblemLists> = (prop) => {
  const { contestId, trackId, stageId } = prop;

  const location = useLocation();
  const history = useHistory();

  const status = useAppSelector((state) => state.user.user);
  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [problems, setProblems] = useState<ProblemModel[]>([]);
  useEffect(() => {
    if (status === "guest") {
          login(location.pathname);
        }
    if (contestId === -1 || trackId === -1) {
      history.push("/404");
    } else {
      fetchProblems(contestId, trackId, stageId)
        .then((data) => {
          setProblems(data);
        })
        .catch((err) => {
          console.log(err);
          setProblems([]);
        });
    }
  }, [location, status, key, id, history, contestId, trackId, stageId]);
  return (
    <Tabs style={{ margin: "-36px -40px", padding: "0" }}>
      {problems.map((x) => (
        <TabPane key={x.id} tab={x.title}>
          <Problem
            {...{ contestId, trackId, stageId }}
            problemId={x.id}
            problem={x}
          />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default ProblemList;
